<e-dialog [open]="open()" (openChange)="open.set($event)" [title]="title()" size="xxl" height="90vh">
  <ng-template>
    <hd-chart-manager
      mode="dialog"
      (loadChartRequested)="onLoad($event)"
      (calculatedChartRequested)="onCalculated($event)"
      (chartsDeleted)="chartsDeleted.emit($event)"
      (chartUpdated)="chartUpdated.emit($event)"
      (gameRequested)="gameRequested.emit()"
      (justNowRequested)="onJustNow()"
      (justNowFullRequested)="onJustNowFull()"
      (raveNewYearRequested)="onRaveNewYear($event)"
      (emptyChartRequested)="onEmptyChart()"
      (timelineRequested)="timelineRequested.emit($event)"
    ></hd-chart-manager>
  </ng-template>
</e-dialog>
